module.exports = __webpack_public_path__ + "media/images/global/projects/content-connections-0d554969599e57b7319923719af9199e.png";